//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/ugmath.js";
let d=[[],[[["numberOfSymbols","indices"],"GetSymbols",{R_:{locations:""}},0,0],[["locations"],"AddSymbol",{},1,0],[["symbolIndex","locations"],"ModifySymbol",{},2,0],[["symbolIndex"],"DeleteSymbol",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.ForeshorteningSymbolBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.ForeshorteningSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;